<template>
  <div>
    <div class="title_h1">見積書等提出</div>
    <vab-collapse-info>
      <template slot="title">
        {{ getFieldValue('demandBaseIdModel.title', info) }}［{{
          getFieldValue('acceptOrderNo', info)
        }}］
      </template>
      <template v-if="showDownLoad" slot="upload">
        <div
          class="flex_center_align"
          @click="
            downLoadInfomation(
              '/api/scheduleAdjAnswer/partner/estimate/download'
            )
          "
        >
          <span>見積情報ダウンロード</span>
          <svg-icon icon-class="download_2_line" class="upload_svg"></svg-icon>
        </div>
      </template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{ getFieldValue('buildingCdModel.blgsnmkj', info) }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">商品</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{ getFieldValue('demandBaseIdModel.itemCdModel.itmnm', info) }}
          </vab-col>
          <vab-col :span="4" class="title_box">商品明細</vab-col>
          <vab-col :span="8" class="word_box center_box">
            <div
              v-for="(item, index) in mitmdtlpModelList"
              :key="index"
              class="flex_space width_100"
            >
              <div>
                {{ getFieldValue('itmdtlnm', item) }}
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">依頼件名</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{ getFieldValue('requestIdModel.constructionName', info) }}
          </vab-col>
        </vab-row>

        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">案件分類</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('demandBaseIdModel.businessForm', info),
                $divisions.consignmentWorkClassEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">依頼区分</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('requestIdModel.requestClass', info),
                $divisions.requestClassEnum
              )
            }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">進行部門</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getFieldValue(
                'demandBaseIdModel.progressDepCdModel.orgkjrn',
                info
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">進行担当者</vab-col>
          <vab-col :span="8" class="word_box center_box">
            <div
              v-for="(item, index) in getFieldValue(
                'demandBaseIdModel.demandChargePersonModelList',
                info
              )"
              :key="index"
            >
              {{ getFieldValue('empnmkj', item.chargePersonCdModel) }}
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">書類提出期限</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{ getFieldValue('requestIdModel.docLimitDate', info) }}
          </vab-col>
          <vab-col :span="4" class="title_box">書類状況</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('docSubmitStatus', info),
                $divisions.docSubmitStatusEnum
              )
            }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">工事内容</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{ getFieldValue('requestIdModel.constructionDetail', info) }}
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>

    <div class="info_main">
      <vab-form ref="form" :model="form">
        <vab-file ref="vabFile">
          <div slot="hd_title">書類提出</div>
        </vab-file>
        <div class="sure_box">
          <vab-row class="row_box">
            <vab-col :span="4" class="title_box">協力会社コメント</vab-col>
            <vab-col :span="20" class="word_box nopadding2 pdtb8">
              <vab-textarea
                type="textarea"
                prop="docComment"
                rows="5"
                maxlength="2340"
              ></vab-textarea>
            </vab-col>
          </vab-row>
          <vab-message
            ref="vabMessage"
            :title="'コメント履歴を閉じる'"
            :msg-type="$divisions.adjSourceClassEnum.enum_1.value"
            class="noborder"
          ></vab-message>
        </div>
      </vab-form>
      <div class="flex_end mg12">
        <vab-button :btn-list="btnList"></vab-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { getRequestDocumentsInfo } from '@/api/scheduleAdjustment'
  import {
    requestDocumentsRelation,
    requestDocumentInit,
    updateBook,
  } from '@/api/requestDocuments'
  import mixinPage from '@/utils/mixinPage'
  import mixinSchedule from '@/utils/mixinSchedule'
  export default {
    name: 'PWS02G04',
    mixins: [mixinPage, mixinSchedule],
    data() {
      return {
        form: {},
        info: {
          itemCdModel: {},
          buildingCdModel: {},
          purchaseOrderDepCdModel: {},
          progressPersonCdModel: {},
        },
        submitDocSet: '',
        btnList: [
          {
            name: '提出',
            icon: 'answer',
            // msg: this.$t(`validateMessage.${this.$messageCode.E00000363.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000452.name}`
            ),
            type: 'button',
            hidden: false,
            click: (row) => {
              this.submitBefore(row)
            },
          },
        ],
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
      initData() {
        // 依頼詳細ｉｄ
        let requestDetailId = this.$route.query?.requestDetailId
        // 依頼詳細ｉｄ
        if (requestDetailId) {
          this.getScheduleAdjRequestInfo(requestDetailId)
        }
      },
      // 詳細はこちら
      async getScheduleAdjRequestInfo(requestDetailId) {
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await getRequestDocumentsInfo(requestDetailId)
          this.info = res
          // 提出書類
          if (res && res?.requestIdModel?.submitDocSet) {
            this.submitDocSet = res?.requestIdModel?.submitDocSet
            await this.requestDocumentInit(res?.requestIdModel?.submitDocSet)
            await this.getRequestDocuments(res?.requestIdModel?.submitDocSet)
          } else {
            this.$refs.vabFile.btnList[0].hidden = true
          }
          // 書類コメント
          this.setBookMessage(res?.docComment)
          this.setGoodsInfoList(this.info)
        } finally {
          loadingInstance.close()
        }
      },
      // 書類マスト情報を取得
      async requestDocumentInit(submitDocSet) {
        let params = {
          requestDetailId: this.getFieldValue('requestDetailId', this.info),
          docIdList: JSON.parse(submitDocSet),
        }
        let list = await requestDocumentInit(params)
        list.filter((item) => {
          item.docName = this.setOtherBookName(
            this.getFieldValue('requestIdModel.submitEtcText', this.info),
            item
          )
          item.docIdModel = {
            docId: item.docId,
            docName: item.docName,
          }
        })
        this.initList = list
        this.checkList = list
      },
      // 提出書類リスト情報を取得
      async getRequestDocuments(submitDocSet) {
        let params = {
          requestDetailId: this.getFieldValue('requestDetailId', this.info),
          docIdList: JSON.parse(submitDocSet),
        }
        let list = (await requestDocumentsRelation(params)) || []
        // ページの統合に必要なデータ
        let data = {
          // 協力会社
          roleType: this.$divisions.notifyTypeEnum.work,
          // 書類提出
          fileType: this.$divisions.bookTypeEnum.document,
          // 依頼詳細ＩＤ
          requestDetailId: this.getFieldValue('requestDetailId', this.info),
          // 建物CD
          buildingCd: this.getFieldValue(
            'demandBaseIdModel.buildingCd',
            this.info
          ),
          // 受注キー
          acceptOrderKey: this.getFieldValue('acceptOrderNo', this.info),
        }
        this.setOperationTypeFileList(list)
        this.realFileList = list
        if (list && list.length > 0) {
          this.initList = [...this.initList, ...list]
        }
        this.paramsData = data
        this.setFileList(list.length > 0)
      },
      // 書類の提出を行ってください
      setFileList(showUpload) {
        let list = this.getFileList(this.initList, this.paramsData)
        let docIdList = this.initList
          .filter((item) => item.fileName)
          .map((row) => row?.docIdModel?.docId)
        this.$refs.vabFile.setList(list, this)
        this.$refs.vabFile.initData(
          {
            ...this.paramsData,
            docIdList,
          },
          showUpload
        )
      },
      // ファイルの削除
      delFileListById(file) {
        let list = this.$baseLodash.cloneDeep(this.initList)
        list.filter((item, index) => {
          if (item.reqDocId == file.reqDocId) {
            list.splice(index, 1)
          }
        })
        this.initList = list
        this.realFileList.filter((item, index) => {
          if (item.reqDocId == file.reqDocId) {
            item.operationType = this.$divisions.operationTypeEnum.enum_D.value
            this.deleteList.push(item)
            this.realFileList.splice(index, 1)
          }
        })
        this.setFileList(this.realFileList.length > 0)
      },
      reloadBook() {
        this.initList = [...this.checkList]
        this.getRequestDocuments(this.submitDocSet)
      },
      // 提出前
      submitBefore(row) {
        const { check, docName } = this.checkBookRequired({
          roleType: this.$divisions.notifyTypeEnum.work,
        })
        if (!check) {
          this.$confirm({
            msg: this.format(
              this.$t(`validateMessage.${this.$messageCode.E00000323.name}`),
              docName
            ),
            enableCancel: false,
            yes: () => {},
          })
          return
        }
        this.$confirm({
          msg: this.format(
            this.$t(`validateMessage.${this.$messageCode.I00000301.name}`),
            row.name
          ),
          yes: () => {
            this.submitForm(row)
          },
        })
      },
      // 提出
      async submitForm(row) {
        let submitData = {}
        let info = this.$baseLodash.cloneDeep(this.info)
        submitData = {
          ...info,
          docComment: this.getBookMessage(this.form.docComment),
          requestDocumentsModelList: this.getRealFileList(),
        }
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await updateBook(submitData)
          if (!res) {
            this.msgSuccess(row.word)
            this.$closePage(this.$route.path)
            this.$routerPushAndReload({
              path: '/pws/PWS02G01',
              refresh: 'PWS02G01',
            })
          }
        } finally {
          loadingInstance.close()
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tableInfo {
    overflow: hidden;
    border: 1px solid #d1dae1;
    border-radius: $base-border-radius3;
    .ts_box {
      padding: 10px 12px;
      background: #fff;
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #003350;
      }
    }
  }
</style>
